import React from "react";
import { FaShoppingCart, FaHeart, FaSearch, FaUserLock } from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import "./style/Header.css";

const Header = ({
    searchQuery,
    setSearchQuery,
    cart,
    wishlist,
    onCartClick,
    onWishlistClick,
    onAdminClick
}) => {
    return (
        <div
            className="products-header"
            style={{
                backgroundColor: myCustomTheme.colors.header_footer_bg,
                boxShadow: myCustomTheme.shadows.soft
            }}
        >
            <h1
                className="products-header-title"
                style={{
                    color: myCustomTheme.colors.heading,
                    fontFamily: myCustomTheme.typography.heading_font
                }}
            >
                Our Products
            </h1>

            <div className="products-header-right">
                <div className="products-search-box">
                    <FaSearch
                        className="products-search-icon"
                        style={{ color: myCustomTheme.colors.menu_text }}
                    />

                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            border: `1.5px solid ${myCustomTheme.colors.bg_secondary}`,
                            backgroundColor: myCustomTheme.colors.bg_secondary,
                            color: myCustomTheme.colors.heading
                        }}
                    />
                </div>

                <div className="top-buttons">
                    <button
                        className="admin-profile-btn"
                        onClick={onAdminClick}
                        title="Admin Dashboard Login"
                        style={{
                            backgroundColor: myCustomTheme.colors.button_bg,
                            color: myCustomTheme.colors.button_text
                        }}
                    >
                        <FaUserLock />
                    </button>

                    <button
                        className="cart-btn"
                        onClick={onCartClick}
                        style={{
                            backgroundColor: myCustomTheme.colors.button_bg,
                            color: myCustomTheme.colors.button_text
                        }}
                    >
                        <FaShoppingCart />
                        <span
                            className="badge-count"
                            style={{
                                backgroundColor: myCustomTheme.colors.high_light,
                                color: myCustomTheme.colors.heading
                            }}
                        >
                            {cart.length}
                        </span>
                    </button>

                    <button
                        className="wishlist-btn"
                        onClick={onWishlistClick}
                        style={{
                            backgroundColor: myCustomTheme.colors.button_bg,
                            color: myCustomTheme.colors.button_text
                        }}
                    >
                        <FaHeart />
                        <span
                            className="badge-count"
                            style={{
                                backgroundColor: myCustomTheme.colors.high_light,
                                color: myCustomTheme.colors.heading
                            }}
                        >
                            {wishlist.length}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Header;